import { BrowserRouter, Switch, Route } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import Signup from "./components/auth/Signup"
import MainPage from "./components/Dashboard/MainPage/index"
import Loading from "./loading"
import { useSelector } from "react-redux"
import store from "./redux/store"

export const isUserLoggedIn = () => (store?.getState()?.auth?.token ? true : false)

export default function Router() {
    const loading = useSelector(state => state.general.loading)

    return (<BrowserRouter basename={"/"}>
        {loading && <Loading />}
        <ToastContainer />
        <Switch>
            <>
                <Route exact path={`/`} component={MainPage} />
                <Route exact path={`/:route`} component={MainPage} />
                <Route exact path={`/auth/signup`} component={Signup} />
            </>
        </Switch>
    </BrowserRouter>)
}